class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector(".search-field__input")
        this.predictiveSearchResults = this.querySelector('.predictive-search__content');
        this.search_box = this.querySelector(".search-box ")
        this.search_button = document.querySelector(".search-button")
        this.close_search_button = this.querySelector(".search__button-toggle")
        this.modal_overlay = this.querySelector(".modal-overlay")
        this.setupEventListeners()
    }

    setupEventListeners() {
        if(this.modal_overlay){
        this.modal_overlay.addEventListener("click",()=>{
            this.closeSearch();
        })
        }
        this.close_search_button.addEventListener("click", () => {
            this.closeSearch();
        })

        this.search_button.addEventListener("click", () => {
            this.search_box.style.visibility="visible"
            this.search_box.style.display="inline-flex"
            this.search_box.style.opacity="1"
            this.search_box.classList.add("open")
            document.body.classList.add('overflow-hidden');
            this.input.focus();
        })

        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    closeSearch() {
        this.search_box.style.visibility="hidden"
        this.search_box.style.opacity="0"
        this.search_box.classList.remove("open")
        document.body.classList.remove("overflow-hidden");
        this.input.value=""
        this.input.blur();
    }

    getQuery() {
        return this.input.value.trim();
    }

    switchOption(direction) {
        if (!this.getAttribute('open')) return;
        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
        const allElements = this.querySelectorAll('.predictive-search__item');
        let activeElement = this.querySelector('.predictive-search__item');
        if (moveUp && !selectedElement) return;

        if (!moveUp && selectedElement) {
            activeElement = selectedElement.nextElementSibling || allElements[0];
        } else if (moveUp) {
            activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
        }

        if (activeElement === selectedElement) return;
        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
        const selectedProduct = this.querySelector('[aria-selected="true"], [aria-selected="true"] button');

        if (selectedProduct) selectedProduct.click();
    }

    onFocus() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) return;

        if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(searchTerm);
        }
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    onKeyup(event) {

        if (!this.getQuery().length) this.close(true);
        event.preventDefault();

        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up')
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
            case 'Escape':
                this.closeSearch();
                break;
        }
    }

    onKeydown(event) {
        if (
            event.code === 'ArrowUp' ||
            event.code === 'ArrowDown'
        ) {
            event.preventDefault();
        }
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(
          `${window.routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`
        )
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            this.predictiveSearchResults.innerHTML = text;
            this.open();
          })
          .catch((error) => {
            logger.error(error);
            this.close();
          });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
        this.setAttribute('open', true);
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }
}

customElements.define('predictive-search', PredictiveSearch);
